/** Importe escrito en castellano («1.500,50», «1500,5» o «1500.5») → 1500.5; null si no es un número. */
export const leerImporte = (texto: string): number | null => {
  const limpio = texto.trim().replace(/\s|€/g, "");
  if (!limpio) return null;
  // Con coma, la coma es el decimal y los puntos son miles («1.500,50»). Sin coma, los
  // puntos son miles si agrupan de tres en tres («2.000», «1.250.000»); si no, decimal.
  const normal = limpio.includes(",")
    ? limpio.replace(/\./g, "").replace(",", ".")
    : /^\d{1,3}(\.\d{3})+$/.test(limpio)
      ? limpio.replace(/\./g, "")
      : limpio;
  const n = Number(normal);
  return Number.isFinite(n) ? n : null;
};

/** Importe para un campo de texto: 1500.5 → «1500,5» (sin separador de miles). */
export const importeATexto = (n?: number | null): string =>
  n == null ? "" : String(Math.round(n * 100) / 100).replace(".", ",");
